var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('upload',{ref:"upload"}),_c('div',{staticStyle:{"display":"none"}},[_c('button',{ref:"clipboard",attrs:{"id":"clipboard","data-clipboard-action":"copy","data-clipboard-text":_vm.clipboardText}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }